export default __webpack_public_path__ + "static/media/ovel-shape.8277551c.png";